export default {
  labels: {
    dont_have_account: 'Non hai un account? ',
  },
  title: 'Unisciti a {{name}}!',
  default_program_name: 'Club Premi',
  buttons: {
    sign_up: 'Registrati',
  },
};
